import { addLiveChat, addSupportForm, addTrackingCode, automateEmail, automateForm, buildAiWebsite, connectAdsAccount, connectAndCreateAds, connectCalendar, connectChannel, connectDomain, connectYourTeamEmail, createBot, createContact, createCustomRecordProperty, createCustomProperty, createDeal, createList, createMarketingReportingDashboard, createRoutingRuleset, createSalesReportingDashboard, createSimpleForm, createSimpleFormStarter, editDealStages, filterContacts, helpDeskAddUsers, helpDeskConnectChannel, helpDeskCustomizeTickets, helpDeskSetupSlas, importContacts, inviteYourTeam, setupPersonalMeetingsLink, tourContactRecord, createEmail, configureTicketAutomation, connectYourDomainTask, createLandingPage, postFirstBlog, publishChatbot, publishFirstWebpageTask, publishLandingPage, selectStyleV2, explorePublishSite, quickImportContacts, renameDealPipeline, selectActiveTheme, selectSalesEmailTemplate, setupSalesPipeline, setupTicketPipeline, addDataModal, learnAboutPayments, createAPaymentLink, createABlogPost, paymentsActivationProfessionalServicesCreate, paymentsActivationProfessionalServicesUse, paymentsActivationSubscriptionsCreate, paymentsActivationSubscriptionsUse, paymentsActivationPaidContentCreate, paymentsActivationPaidContentUse, paymentsActivationProjectsCreate, paymentsActivationProjectsUse, paymentsActivationPhysicalGoodsCreate, paymentsActivationPhysicalGoodsUse, paymentsActivationDonationsCreate, paymentsActivationDonationsUse, seoRecommendations, remixContent, createPodcast, setupBrandVoice, setupBranding, embedSmartContent, createAnInvoice, createAQuote, createPaymentLink, testCheckout, paymentsCustomizeCheckout, paymentsAddBankAccount, paymentsSetUpQuickBooksIntegration, sendYourFirstSalesEmail, trackEmailPerformance, trackServicePerformance, trackWebsitePerformance, commerceCreateDeal, commerceCreateSubscription, commerceConnectSync, commerceCreateProduct, commerceReportingDashboard, commerceCollectPayments, commerceCreateASubscriptionPaymentLink, commerceCreateASubscriptionInvoice, commerceCreateAQuoteMilestoneBilling, commerceConvertDealToTool, createFormDiscoveryModeExperiment, addFormLandingPageDiscoveryModeExperiment, promoteLandingPageDiscoveryModeExperiment, commerceSetUpPaymentsMarketing, commerceSetUpPaymentsCharge, commerceSetUpPaymentsInvoices, commerceSetUpPaymentsMilestone, commerceSetUpPaymentsSubscriptions, commerceSetUpPaymentsDeals, emailSequenceCreation, setSalesGoals, setMarketingContacts, addBusinessLocation, addEmailSubscriptionPreferences, turnOnGDPR, createWorkflow, connectSocialAccount, connectAdAccount, createAdAudience, activateEmailSequence, connectPhone, identifyLeadsInCrm, addKeySalesReportingDashboard, createSalesPlanTemplate } from 'getting-started-shared-tasks/taskNames';
/**
 * Configuration for enabling task handholding banner.
 *
 * `taskKey` is task key from user-context which has copy in getting-started-shared-tasks
 * `routes` are array for the urls that banner will be displayed,
 * `route` item format is same as react-router route path
 *
 * [taskKey]: {
 *   routes: ['/route-path-with-banner'],
 * },
 */
export const TASK_BANNER_CONFIGS = {
  [addLiveChat]: {
    showCompletionModalOnLastRoute: true,
    routes: ['/live-messages-settings/:portalId/onboarding?channelType=LIVE_CHAT', '/live-messages-settings/:portalId/inboxes/:inboxId/live-chat/create', '/live-messages/:portalId/inbox(.*)']
  },
  [addTrackingCode]: {
    routes: ['/user-guide/:portalId', '/settings/:portalId/analytics-and-tracking/tracking']
  },
  [addSupportForm]: {
    routes: ['/live-messages-settings/:portalId/onboarding', '/live-messages-settings/:portalId/inboxes/:inboxId/channels', '/live-messages-settings/:portalId/inboxes/:inboxId/forms/create', '/forms/:portalId/editor/:editorId/edit/form(.*)?']
  },
  [automateEmail]: {
    routes: ['/email/:portalId/edit']
  },
  [automateForm]: {
    routes: ['/forms/:portalId/editor']
  },
  [buildAiWebsite]: {
    routes: ['/website/:portalId/pages/site', '/cms-onboarding/:portalId/ai-website-builder/flow', '/active-theme-create/:portalId', '/pages/:portalId/editor']
  },
  [connectAdsAccount]: {
    showCompletionModalOnLastRoute: true,
    routes: ['/ads/:portalId/onboarding-wizard(.*)?', {
      path: '/ads/:portalId',
      exact: true
    }]
  },
  [connectAndCreateAds]: {
    showCompletionModalOnLastRoute: true,
    routes: ['/ads/:portalId/onboarding-wizard(.*)?', {
      path: '/ads/:portalId',
      exact: true
    }]
  },
  [connectCalendar]: {
    routes: ['/settings/:portalId/user-preferences/calendar']
  },
  [connectChannel]: {
    routes: ['/live-messages-settings/:portalId/inboxes', '/live-messages-settings/:portalId/inboxes/:inboxId(.*)?']
  },
  [connectDomain]: {
    routes: ['/domains/:portalId', '/domains/:portalId/add-domain/CONTENT_TYPE/PRIMARY', '/domains/:portalId/add-domain/SELECT_DOMAIN/EMAIL', '/domains/:portalId/add-domain(.*)', '/settings/:portalId/domains', '/settings/:portalId/domains/add-domain(.*)']
  },
  [connectYourTeamEmail]: {
    showCompletionModalOnLastRoute: true,
    routes: ['/live-messages-settings/:portalId/onboarding?channelType=EMAIL', '/live-messages-settings/:portalId/inboxes/:inboxId/email/create', '/live-messages-settings/:portalId/inboxes/:inboxId/edit/email/:emailId', '/live-messages/:portalId/inbox(.*)']
  },
  [createBot]: {
    routes: ['/chatflows/:portalId/create', '/live-messages-settings/:portalId/inboxes/:inboxId/:channel/create(.*)', '/chatflows/:portalId/edit/:channel/:botId(.*)']
  },
  [createContact]: {
    routes: ['/contacts/:portalId/objects/:objectTypeId/views/:viewId/:pageType(.*)', '/contacts/:portalId/record/0-1/:contactId', '/contacts/:portalId/record/0-1/:contactId/view/:viewId', '/onboarding-wizard/:portalId/create-contact']
  },
  [createCustomProperty]: {
    routes: ['/property-settings/:portalId/properties']
  },
  [createCustomRecordProperty]: {
    routes: ['/contacts/:portalId/record/0-1/:contactId', '/onboarding-wizard/:portalId/create-custom-record-property']
  },
  [createDeal]: {
    routes: ['/contacts/:portalId/objects/:objectTypeId/views/:viewId/:pageType', '/contacts/:portalId/record/0-1/:contactId', '/contacts/:portalId/record/0-1/:contactId/view/:viewId', '/contacts/:portalId/record/0-3/:dealId', '/contacts/:portalId/record/0-3/:dealId/view/:viewId', '/onboarding-wizard/:portalId/track-deals', '/prospecting/:portalId/deals/open']
  },
  [createList]: {
    routes: ['/contacts/:portalId/objectLists/all', '/contacts/:portalId/objectLists/create', '/contacts/:portalId/objectLists/:listId', '/contacts/:portalId/lists', '/contacts/:portalId/lists/create', '/contacts/:portalId/lists/:listId']
  },
  [createSimpleForm]: {
    routes: ['/forms/:portalId/type', '/forms/:portalId/templates', '/forms/:portalId/views/all_forms(.*)?', '/forms/:portalId/editor/(.*)?']
  },
  [createSimpleFormStarter]: {
    routes: ['/forms/:portalId/type', '/forms/:portalId/templates', '/forms/:portalId/editor/(.*)?']
  },
  [editDealStages]: {
    routes: ['/pipelines-settings/:portalId/object/0-3', '/leads-settings/:portalId', '/sales-products-settings/:portalId/object/0-136/preview-customization']
  },
  [filterContacts]: {
    routes: ['/contacts/:portalId/objects/:objectTypeId/views/:viewId/:pageType']
  },
  [importContacts]: {
    routes: ['/contacts/:portalId/objects/:objectTypeId/views/:viewId/:pageType', '/contacts/:portalId/objects/:objectTypeId/views/:viewId', '/import/:portalId', '/import/:portalId/new-import', '/data-sync/:portalId/app/:appId/account/:accountId/settings', '/data-sync/:portalId/app/:appId/account/:accountId/settings/connection/create', '/data-sync/:portalId/app/:appId/account/:accountId/settings/connection/:connectionId/(.*)?', '/data-import-table/:portalId']
  },
  [inviteYourTeam]: {
    routes: ['/settings/:portalId/users']
  },
  [setupPersonalMeetingsLink]: {
    routes: ['/meetings/:portalId/', '/meetings/:portalId/setup']
  },
  [tourContactRecord]: {
    routes: ['/contacts/:portalId/objects/:objectTypeId/views/:viewId/:pageType', '/contacts/:portalId/record/0-1/:contactId', '/contacts/:portalId/record/0-1/:contactId/view/:viewId']
  },
  [createEmail]: {
    showCompletionModalOnLastRoute: true,
    routes: ['/content/:portalId/create/email/all(.*)?', '/email/:portalId/edit/:emailId/content', '/email/:portalId/edit/:emailId/preview', '/email/:portalId/edit/:emailId/settings', '/email/:portalId/edit/:emailId/send', '/email/:portalId/details/:emailId/performance', '/email/:portalId/manage(.*)?']
  },
  [createABlogPost]: {
    routes: ['/website/:portalId/blog/posts', '/blog/:portalId/editor/:postId']
  },
  [connectYourDomainTask]: {
    routes: ['/domains/:portalId', '/domains/:portalId/add-domain(.*)?', '/settings/:portalId/domains', '/settings/:portalId/add-domain(.*)?']
  },
  [createLandingPage]: {
    showCompletionModalOnLastRoute: true,
    routes: ['/create/:portalId/landing-page/all-templates(.*)?', '/content/:portalId/edit/:landingPageId/content', '/content/:portalId/edit/:landingPageId/settings', '/content/:portalId/edit/:landingPageId/optimize', '/content-detail/:portalId/landing-page/:landingPageId/performance']
  },
  [postFirstBlog]: {
    showCompletionModalOnLastRoute: true,
    routes: ['/website/:portalId/blog/posts', '/blog/:portalId/editor/:blogId(.*)?', '/content-detail/:portalId/blog-post/:blogId/published']
  },
  [publishChatbot]: {
    routes: ['/chatflows/:portalId', '/live-messages-settings/:portalId/inboxes/:inboxId/:channel/create(.*)', '/chatflows/:portalId/edit/:channel/:botId(.*)']
  },
  [publishFirstWebpageTask]: {
    showCompletionModalOnLastRoute: true,
    routes: ['/website/:portalId/pages/site', '/create/:portalId/site-page(.*)?', '/content/:portalId/edit/:contentId(.*)?', '/content-detail/:portalId/site-page/:contentId/published']
  },
  [publishLandingPage]: {
    showCompletionModalOnLastRoute: true,
    routes: ['/website/:portalId/pages/landing', '/(create|active-theme-create)/:portalId/(create-page/)?landing-page(.*)?', '/(content|pages)/:portalId/(edit|editor)/:blogId(.*)?', '/content-detail/:portalId/landing-page/:blogId/published']
  },
  [selectStyleV2]: {
    routes: ['/theme-editor/:portalId/edit/(.*)']
  },
  [explorePublishSite]: {
    showCompletionModalOnLastRoute: true,
    routes: ['/website/:portalId/pages/site', '/(create|active-theme-create)/:portalId/(create-page/)?site-page(.*)?', '/(content|pages)/:portalId/(edit|editor)/:contentId(.*)?', '/content-detail/:portalId/site-page/:contentId/published']
  },
  [selectActiveTheme]: {
    routes: ['/active-theme-create/:portalId/change-active-theme/site-page/select-theme', '/active-theme-create/:portalId/marketplace', '/marketplace-settings/:portalId/downloads/themes']
  },
  [selectSalesEmailTemplate]: {
    routes: ['/templates/:portalId/library', '/templates/:portalId']
  },
  [createSalesPlanTemplate]: {
    routes: ['/templates/:portalId/library']
  },
  [setupSalesPipeline]: {
    routes: ['/setup-hubspot/:portalId', '/contacts/:portalId/objects/0-3/views/all/board', '/onboarding-wizard/:portalId/track-deals']
  },
  [createMarketingReportingDashboard]: {
    routes: ['/onboarding-wizard/:portalId/reporting-dashboards', '/discover/:portalId/library/dashboards', '/reports-dashboard/:portalId/', '/discover/:portalId/create/dashboards']
  },
  [createSalesReportingDashboard]: {
    routes: ['/onboarding-wizard/:portalId/reporting-dashboards', '/discover/:portalId/library/dashboards', '/reports-dashboard/:portalId/']
  },
  [trackEmailPerformance]: {
    routes: ['/onboarding-wizard/:portalId/reporting-dashboards', '/discover/:portalId/library/dashboards', '/reports-dashboard/:portalId/']
  },
  [trackServicePerformance]: {
    routes: ['/onboarding-wizard/:portalId/reporting-dashboards', '/discover/:portalId/library/dashboards', '/reports-dashboard/:portalId/']
  },
  [trackWebsitePerformance]: {
    routes: ['/onboarding-wizard/:portalId/reporting-dashboards', '/discover/:portalId/library/dashboards', '/reports-dashboard/:portalId/']
  },
  [renameDealPipeline]: {
    routes: ['/pipelines-settings/:portalId/object/0-3/default']
  },
  [quickImportContacts]: {
    routes: ['/import/:portalId/new-import/standard', '/email/:portalId/import/mailchimp', '/data-sync/:portalId/app/:appId/account/:accountId/settings', '/data-sync/:portalId/app/:appId/account/:accountId/settings/connection/create', '/data-sync/:portalId/app/:appId/account/:accountId/settings/connection/:connectionId/(.*)?', '/contacts/:portalId/objects/:objectTypeId/views/:viewId', '/contacts/:portalId/objects/:objectTypeId/views/:viewId/:pageType', '/data-import-table/:portalId']
  },
  [addDataModal]: {
    routes: ['/contacts/:portalId/objects/:objectTypeId/views/:viewId/:pageType', '/contacts/:portalId/objects/:objectTypeId/views/:viewId', '/import/:portalId', '/import/:portalId/new-import/standard', '/email/:portalId/import/mailchimp', '/data-sync/:portalId/app/:appId/account/:accountId/settings', '/data-sync/:portalId/app/:appId/account/:accountId/settings/connection/create', '/data-sync/:portalId/app/:appId/account/:accountId/settings/connection/:connectionId/(.*)?', '/data-import-table/:portalId']
  },
  [learnAboutPayments]: {
    routes: ['/settings/:portalId/sales/payments']
  },
  [createAPaymentLink]: {
    routes: ['/payment-links/:portalId']
  },
  [paymentsCustomizeCheckout]: {
    routes: ['/settings/:portalId/account-defaults/branding'],
    showCompletionModalOnLastRoute: false
  },
  [paymentsAddBankAccount]: {
    routes: ['/settings/:portalId/sales/payments/payouts'],
    showCompletionModalOnLastRoute: false
  },
  [paymentsSetUpQuickBooksIntegration]: {
    routes: ['/data-sync/:portalId/app/:appId/account/:accountId/settings/object-view(.*)'],
    showCompletionModalOnLastRoute: false
  },
  [paymentsActivationProfessionalServicesCreate]: {
    routes: ['/share-payments/:portalId', '/payment-links/:portalId'],
    showCompletionModalOnLastRoute: false
  },
  [paymentsActivationProfessionalServicesUse]: {
    routes: ['/share-payments/:portalId', '/forms/:portalId', '/meetings/:portalId', '/website/:portalId', '/active-theme-create/:portalId', '/pages/:portalId', '/settings/:portalId/account-defaults/branding'],
    showCompletionModalOnLastRoute: false
  },
  [paymentsActivationSubscriptionsCreate]: {
    routes: ['/share-payments/:portalId', '/payment-links/:portalId'],
    showCompletionModalOnLastRoute: false
  },
  [paymentsActivationSubscriptionsUse]: {
    routes: ['/share-payments/:portalId', '/forms/:portalId', '/meetings/:portalId', '/website/:portalId', '/active-theme-create/:portalId', '/pages/:portalId', '/settings/:portalId/account-defaults/branding'],
    showCompletionModalOnLastRoute: false
  },
  [paymentsActivationPaidContentCreate]: {
    routes: ['/share-payments/:portalId', '/payment-links/:portalId'],
    showCompletionModalOnLastRoute: false
  },
  [paymentsActivationPaidContentUse]: {
    routes: ['/share-payments/:portalId', '/forms/:portalId', '/meetings/:portalId', '/website/:portalId', '/active-theme-create/:portalId', '/pages/:portalId', '/settings/:portalId/account-defaults/branding'],
    showCompletionModalOnLastRoute: false
  },
  [paymentsActivationProjectsCreate]: {
    routes: ['/share-payments/:portalId', '/payment-links/:portalId'],
    showCompletionModalOnLastRoute: false
  },
  [paymentsActivationProjectsUse]: {
    routes: ['/share-payments/:portalId', '/forms/:portalId', '/meetings/:portalId', '/website/:portalId', '/active-theme-create/:portalId', '/pages/:portalId', '/settings/:portalId/account-defaults/branding'],
    showCompletionModalOnLastRoute: false
  },
  [paymentsActivationPhysicalGoodsCreate]: {
    routes: ['/share-payments/:portalId', '/payment-links/:portalId'],
    showCompletionModalOnLastRoute: false
  },
  [paymentsActivationPhysicalGoodsUse]: {
    routes: ['/share-payments/:portalId', '/forms/:portalId', '/meetings/:portalId', '/website/:portalId', '/active-theme-create/:portalId', '/pages/:portalId', '/settings/:portalId/account-defaults/branding'],
    showCompletionModalOnLastRoute: false
  },
  [paymentsActivationDonationsCreate]: {
    routes: ['/share-payments/:portalId', '/payment-links/:portalId'],
    showCompletionModalOnLastRoute: false
  },
  [paymentsActivationDonationsUse]: {
    routes: ['/share-payments/:portalId', '/forms/:portalId', '/meetings/:portalId', '/website/:portalId', '/active-theme-create/:portalId', '/pages/:portalId', '/settings/:portalId/account-defaults/branding'],
    showCompletionModalOnLastRoute: false
  },
  [configureTicketAutomation]: {
    routes: ['/pipelines-settings/:portalId/object/0-5/:pipelineId/automation'],
    showCompletionModalOnLastRoute: false
  },
  [createRoutingRuleset]: {
    routes: ['/settings/:portalId/routing/rulesets', '/settings/:portalId/routing/rulesets/new'],
    showCompletionModalOnLastRoute: false
  },
  [helpDeskAddUsers]: {
    routes: ['/settings/:portalId/users'],
    showCompletionModalOnLastRoute: false
  },
  [helpDeskConnectChannel]: {
    routes: ['/helpdesk-settings/:portalId/inboxes/channels', '/helpdesk-settings/:portalId/inboxes/connect-channel', '/helpdesk-settings/:portalId/inboxes/(email|forms|facebook-messenger|calling)/create', '/forms/:portalId/editor/:formId/edit'],
    showCompletionModalOnLastRoute: false
  },
  [helpDeskCustomizeTickets]: {
    routes: ['/helpdesk-settings/:portalId/inboxes/ticket-defaults', '/sales-products-settings/:portalId/tickets', '/property-settings/:portalId/properties', '/object-manager-settings/:portalId/creator-editor/0-5'],
    showCompletionModalOnLastRoute: false
  },
  [helpDeskSetupSlas]: {
    routes: ['/helpdesk-settings/:portalId/inboxes/sla'],
    showCompletionModalOnLastRoute: false
  },
  [setupTicketPipeline]: {
    routes: ['/pipelines-settings/:portalId/object/0-5'],
    showCompletionModalOnLastRoute: false
  },
  [seoRecommendations]: {
    routes: ['/content-strategy/:portalId/recommendations(.*)', '/content-strategy/:portalId/recommendations/domains(.*)'],
    showCompletionModalOnLastRoute: false
  },
  [remixContent]: {
    routes: ['/content-remix-ui/:portalId/home', '/content-remix-ui/:portalId/flow(.*)'],
    showCompletionModalOnLastRoute: false
  },
  [createPodcast]: {
    routes: [{
      path: '/podcasts/:portalId',
      exact: true
    }],
    showCompletionModalOnLastRoute: false
  },
  [setupBranding]: {
    routes: ['/settings/:portalId/account-defaults/branding(.*)']
  },
  [setupBrandVoice]: {
    routes: ['/settings/:portalId/account-defaults/branding(.*)', '/settings/:portalId/account-defaults/branding/brand-kit/:brandKitId/brand-voice', '/settings/:portalId/account-defaults/branding/brand-kit/primary/brand-voice'],
    showCompletionModalOnLastRoute: false
  },
  [embedSmartContent]: {
    routes: ['/content-embed/:portalId(.*)', '/embeds/:portalId/editor/:embedId/content'],
    showCompletionModalOnLastRoute: false
  },
  [createAnInvoice]: {
    showCompletionModalOnLastRoute: true,
    routes: ['/invoices/:portalId/invoice/create', '/contacts/:portalId/objects/0-53/views/all/list']
  },
  [createAQuote]: {
    showCompletionModalOnLastRoute: false,
    routes: ['/quotes/:portalId/edit']
  },
  [commerceCreateAQuoteMilestoneBilling]: {
    showCompletionModalOnLastRoute: false,
    routes: ['/quotes/:portalId/edit']
  },
  [createPaymentLink]: {
    showCompletionModalOnLastRoute: false,
    routes: ['/payment-links/:portalId']
  },
  [commerceCreateASubscriptionPaymentLink]: {
    showCompletionModalOnLastRoute: false,
    routes: ['/payment-links/:portalId']
  },
  [commerceCreateASubscriptionInvoice]: {
    showCompletionModalOnLastRoute: false,
    routes: ['billing-wizard-ui/:portalId/create']
  },
  [testCheckout]: {
    showCompletionModalOnLastRoute: false,
    routes: ['/payment-links/:portalId', '/payment-links/:portalId/preview/', '/checkout-preview-ui/:portalId']
  },
  [sendYourFirstSalesEmail]: {
    routes: ['/onboarding-wizard/:portalId/create-sales-pipeline', '/contacts/:portalId']
  },
  [commerceCreateProduct]: {
    showCompletionModalOnLastRoute: false,
    routes: ['/contacts/:portalId/objects/0-7/views/all/list', '/commerce-get-started/:portalId/products']
  },
  [commerceCreateDeal]: {
    showCompletionModalOnLastRoute: true,
    routes: ['/contacts/:portalId/objects/0-3/views/:viewId/:pageType', '/contacts/:portalId/record/0-3/:dealId']
  },
  [commerceCreateSubscription]: {
    showCompletionModalOnLastRoute: false,
    routes: ['/contacts/:portalId/objects/0-69/views/all/list', '/payment-links/:portalId', '/commerce-get-started/:portalId/subscriptions']
  },
  [commerceConnectSync]: {
    routes: ['/ecosystem/:portalId/marketplace/apps/quickbooks-data-sync', '/data-sync/:portalId/app/:appId/account/:accountId/settings/object-view']
  },
  [commerceReportingDashboard]: {
    routes: ['/reports-dashboard/:portalId', '/discover/:portalId/library/dashboards', '/reports-dashboard/:portalId/view/:dashboardId']
  },
  [commerceCollectPayments]: {
    routes: ['/commerce/:portalId/zero-state']
  },
  [commerceConvertDealToTool]: {
    routes: ['/contacts/:portalId/objects/0-3/views/all/list', '/payment-links/:portalId/iframe/create'],
    showCompletionModalOnLastRoute: false
  },
  [commerceSetUpPaymentsMarketing]: {
    showCompletionModalOnLastRoute: false,
    routes: ['/commerce/:portalId']
  },
  [commerceSetUpPaymentsCharge]: {
    showCompletionModalOnLastRoute: false,
    routes: ['/commerce/:portalId']
  },
  [commerceSetUpPaymentsInvoices]: {
    showCompletionModalOnLastRoute: false,
    routes: ['/commerce/:portalId']
  },
  [commerceSetUpPaymentsMilestone]: {
    showCompletionModalOnLastRoute: false,
    routes: ['/commerce/:portalId']
  },
  [commerceSetUpPaymentsSubscriptions]: {
    showCompletionModalOnLastRoute: false,
    routes: ['/commerce/:portalId']
  },
  [commerceSetUpPaymentsDeals]: {
    showCompletionModalOnLastRoute: false,
    routes: ['/commerce/:portalId']
  },
  [createFormDiscoveryModeExperiment]: {
    routes: ['/forms/:portalId/new-editor/:formId(.*)'],
    showCompletionModalOnLastRoute: false
  },
  [addFormLandingPageDiscoveryModeExperiment]: {
    routes: ['/pages/:portalId/editor/:contentId(.*)'],
    showCompletionModalOnLastRoute: false
  },
  [promoteLandingPageDiscoveryModeExperiment]: {
    routes: ['/ads/:portalId/adwords(.*)', '/ads/:portalId/campaigns(.*)', '/ads/:portalId/onboarding-wizard(.*)', '/ads/:portalId/integration(.*)']
  },
  [emailSequenceCreation]: {
    routes: ['/growth-pro-unboxing/:portalId/tours/create-sequence']
  },
  [setSalesGoals]: {
    routes: ['/goals/:portalId/create/:stepId']
  },
  [identifyLeadsInCrm]: {
    routes: ['/prospecting/:portalId/leads/view/open-leads']
  },
  [setMarketingContacts]: {
    routes: ['/contacts/:portalId/objects/0-1/views/all/list']
  },
  [addBusinessLocation]: {
    routes: ['/settings/:portalId/marketing/email/configuration/footer']
  },
  [addEmailSubscriptionPreferences]: {
    routes: ['/settings/:portalId/marketing/email/types']
  },
  [turnOnGDPR]: {
    routes: ['/settings/:portalId/data-privacy']
  },
  [createWorkflow]: {
    routes: ['/workflows/:portalId/templates(.*)?', '/workflows/:portalId/create(.*)?', '/workflows/:portalId/view(.*)?', '/workflows/:portalId/platform/flow/:flowId/edit(.*)?']
  },
  [connectAdAccount]: {
    routes: ['/settings/:portalId/marketing/ads/adAccounts', '/ads/:portalId/onboarding-wizard(.*)']
  },
  [connectSocialAccount]: {
    routes: ['/social/:portalId/welcome', '/social/:portalId/compose', '/social/:portalId/settings/accounts']
  },
  [createAdAudience]: {
    routes: ['/ads/:portalId']
  },
  [activateEmailSequence]: {
    routes: ['/sequences/:portalId(.*)']
  },
  [connectPhone]: {
    routes: ['/settings/:portalId/calling/numbers']
  },
  [addKeySalesReportingDashboard]: {
    routes: ['/reports-list/:portalId/collections/sales', '/reports-list/:portalId/templates/sales/dealVelocity']
  }
};